import React from 'react';
import { ActionButtonDropdownProps } from 'Components/Core/DataTable/types';
import { ActionDropdown } from 'Components/Core/Dropdown';
import styles from '../styles.module.scss';

const ActionButtonDropdown: React.FC<ActionButtonDropdownProps> = (props) => {
  return (
    <div className={styles.actionDropdownWrapper}>
      <ActionDropdown
        {...props}
        popperModifiers={[
          {
            name: 'offset',
            options: {
              offset: [0, 4]
            }
          }
        ]}
      />
    </div>
  );
};

export default ActionButtonDropdown;
